import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { ErrorHandlingService } from '@core/services/error-handling/error-handling.service';
import { SpinnerService } from '@core/spinner.service';
import { ThemeService } from '@core/theme.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { CustomToastComponent } from '@shared/custom-toast/custom-toast.component';
import { HeaderBrandHandlerComponent } from '@shared/header/header-brand-handler/header-brand-handler.component';
import { SharedModule } from '@shared/shared.module';
import { ZbpIconComponent } from '@shared/zbp-icon/zbp-icon';
import { ToastrModule } from 'ngx-toastr';
import {
  BrandedConfirmPasswordComponent
} from './account/branded-account/branded-confirm-password-modal/branded-confirm-password-modal.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EmailNotificationsModalComponent }
  from './email-notifications/email-notifications-modal/email-notifications-modal.component';
import { EmailNotificationsComponent } from './email-notifications/email-notifications.component';
import { LoginModule } from './login/login.module';
import { LogoutComponent } from './logout/logout.component';
import { PreloaderModule } from './shared/preloader/preloader.module';
import { BrandedSiteDownComponent } from './site-down/branded-site-down/branded-site-down.component';

/**
 * Unauthed users are navigated to LoginModule,
 * bypassing the RootModule until they're authenticated.
 * RootModule does register some stores that aren't available in LoginModule.
 */
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule.forBrowser(),
    CoreModule, // singleton module, import only once
    NgbModule,
    ToastrModule.forRoot({
      maxOpened: 3,
      preventDuplicates: true,
      autoDismiss: true,
      disableTimeOut: true,
      closeButton: true,
      tapToDismiss: false,
      toastComponent: CustomToastComponent,
    }),
    LoginModule, // with routing - routing used before AppModule's Routing
    AppRoutingModule,
    ButtonComponent,
    HeaderBrandHandlerComponent,  // initializes HeaderService on app load
    ZbpIconComponent,
    PreloaderModule,
  ],
  declarations: [
    AppComponent,
    LogoutComponent,
    BrandedSiteDownComponent,
    EmailNotificationsComponent,
    EmailNotificationsModalComponent,
    BrandedConfirmPasswordComponent,
    CustomToastComponent,
  ],
  providers: [
    ErrorHandlingService,
    SpinnerService,
    {
      provide: ErrorHandler,
      useClass: ErrorHandlingService,
    },
    provideAppInitializer(async () => inject(ThemeService)),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
